export enum Pages {
  ONBOARDING = 'onboarding',
  GAME = 'game',
  PREFINAL = 'prefinal',
  FINAL = 'final',
}

export interface stateType {
  currentPage: Pages;
  isSound: boolean;
}
